import { MESApiService } from "@dexteel/mesf-core";

export const getMolds = async () => {
  const apiService = new MESApiService();

  return await apiService.callV2("[CAS].[GetMolds]", []);
};
